<template>
  <div>
    <CRow>
      <CCol sm="12">
        <UnitsTable
          :items="units"
          hover
          striped
          border 
          small
          fixed
          caption="Unidades"
          @refresh="refreshItems" 
        />
      </CCol>
    </CRow>
  </div>
</template>

<script>
import UnitsTable from '../../components/configuration/units/UnitsTable.vue'
import ws from '../../services/units';
import store from '../../store'

export default {
  name: 'Units',
  components: { UnitsTable },
  data: function () {
		return {
            units: []
        }
  },
  mounted: async function() {
    this.loading();
    let response = await ws.get();

    if(response.type == "success"){
      this.units = response.data;
    }
    this.loaded();
  },
  methods: {
    async refreshItems (items){
      this.loading();
      let response = await ws.get();

      if(response.type == "success"){
        this.units = response.data;
      }
      this.loaded();
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    }
  }
}
</script>
